import AccessTokenForm from './AccessTokenForm';

export default AccessTokenForm;
